import { Component, h } from 'preact'
import Icon from '../assets'
import Content from '../common/Content'
import EventHeader from './EventHeader'
import EventAttendees, { UserData } from './EventAttendees'
import globals from '../../utils/globals'
import axios from 'axios'
import tracker from '../../components/tracker/publish'
import EventDateFormatter from './EventDateFormatter'
import Phrase from '../../libs/translationsUtils/phrase'
import FeaturedTopicsListAsSearchResults from './FeaturedTopicsListAsSearchResults'

interface Props {
  id: number,
  title: string,
  content: string,
  startAt: number,
  endAt: number,
  isOpenForSignUp: boolean,
  isLoggedInUserAttendee: boolean,
  attendeeCount: number,
  attendees: Array<UserData>,
  attachmentCdn: string,
  type?: string,
  image?: string,
  location?: string,
  link?: string,
  linkLabel?: string,
  confirmationMessage?: string
}

interface Details {
  scheduleAt: string,
  location?: string,
  link?: string,
  linkLabel?: string
}

interface Description {
  content: string
}

interface State {
    isAttendee: boolean,
    isLoading?: boolean,
    showModalEditRsvp: boolean,
    showModalAttendConfirmation: boolean,
    rsvpStatus: boolean,
    page: number,
    isAttendeesLoading: boolean,
    attendeeCount: number,
    attendees: Array<UserData>,
    isLoadingConfirm: boolean,
    isLoadingUpdate: boolean,
    isLoadingAttend: boolean
}

class EventView extends Component<Props, State> {
  isEventEngagementEnabled: boolean
  scheduleAt: string
  constructor (props: Props) {
    super(props)
    this.state = {
      isAttendee: props.isLoggedInUserAttendee,
      isLoading: false,
      showModalEditRsvp: false,
      showModalAttendConfirmation: false,
      rsvpStatus: props.isLoggedInUserAttendee,
      page: 1,
      isAttendeesLoading: false,
      attendeeCount: props.attendeeCount,
      attendees: props.attendees,
      isLoadingConfirm: false,
      isLoadingUpdate: false,
      isLoadingAttend: false
    }
    this.isEventEngagementEnabled = ((globals('activeModules') || []).indexOf('eventEngagement') !== -1)
    this.scheduleAt = EventDateFormatter.formatDateForEventView(props.startAt, props.endAt)
  }

  onAttendanceChanged (isAttending: boolean): void {
    this.setState({ rsvpStatus: isAttending })
  }

  onEditRsvp () {
    this.setState({ showModalEditRsvp: true })
  }

  onCloseModalEditRsvp () {
    this.setState({ showModalEditRsvp: false })
  }

  async onUpdateRsvp (e: Event) {
    e.preventDefault()
    if (this.state.rsvpStatus) {
      this.setState({ showModalEditRsvp: false })
      return
    }
    this.setState({ isLoadingUpdate: true })
    try {
      const res = await axios.post('/event/cancelSignUp', {
        eventId: this.props.id
      })
      this.setState({
        isAttendee: false,
        showModalEditRsvp: false,
        isLoadingAttend: false,
        attendees: res.data,
        attendeeCount: this.state.attendeeCount - 1,
        isAttendeesLoading: false,
        isLoadingUpdate: false
      })
    } catch (e) {
      this.setState({ isAttendee: false, isLoadingAttend: false, isAttendeesLoading: false, isLoadingUpdate: false })
    }
  }

  onCloseModalAttendConfirmation () {
    this.setState({
      showModalAttendConfirmation: false,
      isLoadingAttend: false,
      isLoadingConfirm: false
    })
  }

  async onAttend () {
    if (!window.inSidedData.user.userid) {
      const event = new window.CustomEvent('GuestUserAction')
      window.dispatchEvent(event)
      return
    }
    this.setState({ isLoadingAttend: true })

    try {
      const res = await axios.post('/event/signUp', {
        eventId: this.props.id
      })

      this.setState({
        isAttendee: true,
        rsvpStatus: true,
        attendees: res.data,
        attendeeCount: this.state.attendeeCount + 1,
        isAttendeesLoading: false,
        showModalAttendConfirmation: true
      })

      const { userid, name } = window.inSidedData.user
      const eventId = this.props.id.toString()
      tracker.trackEvent('userevent', {
        'type': 'Event RSVPed',
        'community_id': globals('communityId'),
        'destination_event_url': window.location.href,
        'author_id': userid,
        'author_name': name,
        'event_id': eventId,
        'event_title': this.props.title
      })
    } catch (e) {
      this.setState({
        isAttendee: false,
        isLoadingAttend: false,
        isAttendeesLoading: false,
        isLoadingConfirm: false,
        showModalAttendConfirmation: false })
    }
  }

  async loadNextPage () {
    this.setState({ isLoading: true })
    try {
      const res = await axios.get(`/events/${this.props.id}/attendees?page=${this.state.page + 1}`)
      this.setState({ page: this.state.page + 1, attendees: this.state.attendees.concat(res.data) })
    } catch (e) {}

    this.setState({ isLoading: false })
  }

  render ({ id, title, type, startAt, endAt, image, location, link, linkLabel, content, isOpenForSignUp, isLoggedInUserAttendee, attachmentCdn, confirmationMessage }: Props, { isAttendee, isLoading, showModalEditRsvp, rsvpStatus, isAttendeesLoading, page, attendees, attendeeCount, showModalAttendConfirmation, isLoadingAttend, isLoadingConfirm, isLoadingUpdate }: State) {
    return (
      <div>
        <EventHeader eventId={id}
          title={title}
          scheduleAt={this.scheduleAt}
          startAt={startAt}
          endAt={endAt}
          isOpenForSignUp={isOpenForSignUp}
          isLoggedInUserAttendee={isLoggedInUserAttendee}
          image={image}
          type={type}
          confirmationMessage={confirmationMessage}
          isEventEngagementEnabled={this.isEventEngagementEnabled}
          isAttendee={isAttendee}
          isLoadingAttend={isLoadingAttend}
          showModalEditRsvp={showModalEditRsvp}
          showModalAttendConfirmation={showModalAttendConfirmation}
          onCloseModalAttendConfirmation={() => this.onCloseModalAttendConfirmation()}
          rsvpStatus={rsvpStatus}
          onAttend={() => this.onAttend()}
          onEditRsvp={() => this.onEditRsvp()}
          onCloseModalEditRsvp={() => this.onCloseModalEditRsvp()}
          onAttendanceChanged={(value: any) => this.onAttendanceChanged(value)}
          onUpdateRsvp={(e: Event) => this.onUpdateRsvp(e)}
          isLoadingConfirm={isLoadingConfirm}
          isLoadingUpdate={isLoadingUpdate}
        />
        <div className='event-body-container'>
          <div className='event-content-wrapper'>
            <EventContent content={content} />
            <EventAttendees
              isPastEvent={EventDateFormatter.isPastEvent(endAt)}
              eventId={id}
              attendees={attendees}
              attendeeCount={attendeeCount}
              page={page}
              isEventEngagementEnabled={this.isEventEngagementEnabled}
              isLoading={isAttendeesLoading}
              loadNextPage={() => this.loadNextPage()}
            />
            <FeaturedTopicsListAsSearchResults eventId={id} attachmentCdn={attachmentCdn} />
          </div>
          <EventDetails scheduleAt={this.scheduleAt} location={location} link={link} linkLabel={linkLabel} />
        </div>
      </div>
    )
  }
}

const EventDetails = ({ scheduleAt, location, link, linkLabel }: Details) => {
  return (
    <div className='event-details-wrapper'>
      <div className='event-details-container'>
        <div className='event-details__header_label'><Phrase p='events.details' m='Forum' /></div>
        <div className='event-detail-row'>
          <div className='event-detail-icon'>
            <Icon icon='clock' />
          </div>
          <div className='event-detail-info'>
            <div className='event-detail__label'><Phrase p='events.datetime' m='Forum' /></div>
            <div>{scheduleAt}</div>
          </div>
        </div>
        {location &&
        <div className='event-detail-row'>
          <div className='event-detail-icon' style={{ padding: '0 3px' }}>
            <Icon icon='location' width={13} height={16} />
          </div>
          <div className='event-detail-info'>
            <div className='event-detail__label'><Phrase p='events.location' m='Forum' /></div>
            <div>{location}</div>
          </div>
        </div>
        }
        {link &&
        <div className='event-detail-row'>
          <div className='event-detail-icon'>
            <Icon icon='link' />
          </div>
          <div className='event-detail-info'>
            <div className='event-detail__label'><Phrase p='events.link' m='Forum' /></div>
            <a className='event-detail__link' href={link} target='_blank' >{linkLabel}</a>
          </div>
        </div>
        }
      </div>
    </div>)
}

const EventContent = ({ content }: Description) => {
  return (
    <div className='event-content-container'>
      <div className='event-content__header_label'><Phrase p='events.about' m='Forum' /></div>
      <Content content={content} className='event__content' />
    </div>
  )
}

export default EventView
